import { buildFundingClubDirectoryPageUrl } from "@mixitone/util";

export function directoryBaseUrlFromEnv(): string {
  return import.meta.env.VITE_DIRECTORY_URL || "http://localhost:4321";
}

export type ClubDirectoryListingInput = {
  id?: string | null;
  country?: string | null;
  listed_in_directory?: boolean | null;
  directory_slug?: string | null;
};

/** Canonical public directory URL for a club, preferring directory_slug when set. */
export function clubDirectoryListingUrl(club: ClubDirectoryListingInput): string | null {
  const clubId = club.id?.trim();
  if (!clubId || !club.listed_in_directory) return null;

  return buildFundingClubDirectoryPageUrl({
    directoryBaseUrl: directoryBaseUrlFromEnv(),
    clubId,
    directorySlug: club.directory_slug,
    clubCountry: club.country,
    listedInDirectory: club.listed_in_directory,
  });
}
